import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, of } from 'rxjs';
import { takeUntil, tap, catchError } from 'rxjs/operators';
import { InfoService } from "@app/shared/services/info.service";
import { FeedbackService } from "@app/shared/services/feedback.service";

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class InfoComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  mainApiInfo: string;

  constructor(
    private infoService: InfoService,
    private feedbackService: FeedbackService
  ) { }

  ngOnInit(): void {
    this.getMainApiInfo();
  }

  getMainApiInfo() {
    this.infoService.getMainApiInfo().pipe(
      tap(data => {
        this.mainApiInfo = data;
      }),
      catchError((error) => {
        this.feedbackService.error("There was a problem fetching main API info.");
        console.error(error);
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
